module.exports = __webpack_public_path__ + "img/print_code_new.fe079ae2.png";